// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"72ce56c8c6f612f9396c","655":"83ccbfe4fe40f45ff96b"}[chunkId] + ".js";
};